
const EXCLUDED_PM_ENTITYID_FOR_CHATBOT = {
    TCS: 1006639,
    WELLS_FARGO: 11185545,
    RETAIL: 1018900
}

module.exports = { EXCLUDED_PM_ENTITYID_FOR_CHATBOT }



